/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaymentProvider } from './PaymentProvider';
import {
    PaymentProviderFromJSON,
    PaymentProviderFromJSONTyped,
    PaymentProviderToJSON,
    PaymentProviderToJSONTyped,
} from './PaymentProvider';

/**
 * 
 * @export
 * @interface PaymentMethodDto
 */
export interface PaymentMethodDto {
    /**
     * 
     * @type {Date}
     * @memberof PaymentMethodDto
     */
    created: Date;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodDto
     */
    externalId: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodDto
     */
    paymentMethod: string;
    /**
     * 
     * @type {PaymentProvider}
     * @memberof PaymentMethodDto
     */
    paymentProvider: PaymentProvider;
}



/**
 * Check if a given object implements the PaymentMethodDto interface.
 */
export function instanceOfPaymentMethodDto(value: object): value is PaymentMethodDto {
    if (!('created' in value) || value['created'] === undefined) return false;
    if (!('externalId' in value) || value['externalId'] === undefined) return false;
    if (!('paymentMethod' in value) || value['paymentMethod'] === undefined) return false;
    if (!('paymentProvider' in value) || value['paymentProvider'] === undefined) return false;
    return true;
}

export function PaymentMethodDtoFromJSON(json: any): PaymentMethodDto {
    return PaymentMethodDtoFromJSONTyped(json, false);
}

export function PaymentMethodDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentMethodDto {
    if (json == null) {
        return json;
    }
    return {
        
        'created': (new Date(json['created'])),
        'externalId': json['externalId'],
        'paymentMethod': json['paymentMethod'],
        'paymentProvider': PaymentProviderFromJSON(json['paymentProvider']),
    };
}

export function PaymentMethodDtoToJSON(json: any): PaymentMethodDto {
    return PaymentMethodDtoToJSONTyped(json, false);
}

export function PaymentMethodDtoToJSONTyped(value?: PaymentMethodDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'created': value['created'].toISOString(),
        'externalId': value['externalId'],
        'paymentMethod': value['paymentMethod'],
        'paymentProvider': PaymentProviderToJSON(value['paymentProvider']),
    };
}

